var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sanitizedValue)?_c('span',{class:_vm.classes},[(_vm.displayIcon)?_c('b-icon-telephone'):_vm._e(),_c('b-link',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.openDialog.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.sanitizedValue)+" ")]),_c('PhoneNumberActionDialog',{ref:"dialog"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }